import React from "react";
import PropTypes from "prop-types";

import { Message } from "semantic-ui-react";

function SectionError({ children, ...props }) {
  return children ? (
    <Message negative {...props}>
      {children}
    </Message>
  ) : null;
}

SectionError.propTypes = { children: PropTypes.node };

SectionError.defaultProps = { children: null };

export default SectionError;
